import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SubmissionDetails from '../../../SubmissionDetails';
import GruserZoneLocal from '../../GruserZone/Local';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import { DetailsProps } from '../types';
import ExtendedDetails from './ExtendedDetails';

import s from './Default.scss';

interface Props extends DetailsProps {
  bottomSlot?: React.ReactNode;
  showTitle?: boolean;
  withGruserZone?: boolean;
  withDividerBelowStats?: boolean;
}

export const DefaultDetails: React.FC<Props> = ({
  deviation,
  className,
  contentClassName,
  bottomSlot,
  showTitle = true,
  withGruserZone = true,
  withDividerBelowStats = true,
}) => {
  const isMobile = useContext(MobileContext);
  const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);

  return (
    <div className={classnames(s['root'], className, contentClassName)}>
      <div className={s['title-block']}>
        <SubmissionDetails deviation={deviation} showTitle={showTitle} />
      </div>
      {isExtendedLoaded && (
        <ExtendedDetails
          deviation={deviation}
          withDividerBelowStats={withDividerBelowStats}
        />
      )}
      {!isMobile && withGruserZone && <GruserZoneLocal deviation={deviation} />}
      {bottomSlot && <div className={s['bottom-slot']}>{bottomSlot}</div>}
    </div>
  );
};
DefaultDetails.displayName = 'DefaultDetails';

export default DefaultDetails;
